import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconHelpQuery = deprecatedComponent({
    displayName: 'IconHelpQuery',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M11.7288 2C6.50079 2 2.2233 6.27749 2.2233 11.5055C2.2233 13.4066 2.77779 15.2285 3.80756 16.7336L2.2233 20.4566C2.06488 20.7734 2.38173 21.0903 2.77779 21.0111L6.50079 19.4268C8.00584 20.4566 9.82773 21.0111 11.7288 21.0111C16.9569 21.0111 21.2344 16.7336 21.2344 11.5055C21.2344 6.27749 16.9569 2 11.7288 2Z",
            stroke: "black",
            strokeWidth: 1.5,
            strokeMiterlimit: 10,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("ellipse", {
            cx: 11.7296,
            cy: 15.4679,
            rx: 0.792128,
            ry: 0.792127,
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M11.729 13.4073L11.6498 11.8231C12.9172 11.8231 14.0262 10.7933 14.0262 9.4467C14.0262 8.10008 12.9964 7.07031 11.6498 7.07031C10.3032 7.07031 9.27344 8.10008 9.27344 9.4467H9.35265C9.35265 8.10008 10.4616 7.07031 11.729 7.07031C12.9964 7.07031 14.1054 8.17929 14.1054 9.4467C14.1054 10.7933 13.0757 11.8231 11.729 11.8231V13.4073Z",
            stroke: "black",
            strokeWidth: 1.58426,
            strokeMiterlimit: 10,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconHelpQuery };
